import React, {useEffect, useState} from "react";
import ArrowIcon from "../../assets/arrow.svg";
import styled, { css } from 'styled-components';
import Dropdown from 'react-dropdown';
import 'react-dropdown/style.css';
import { PersonalInformationCard } from "../PersonalInformationCard";
import {PreferencesCard} from "../PreferencesCard";
import {BeneficiaryCard} from "../BeneficiaryCard";
import {PensionBeneficiariesCard} from "../PensionBeneficiariesCard";
import {PlanningInformationCard} from "../PlanningInformationCard";
import {AboutYourselfCard} from "../AboutYourselfCard";
import {LoginInformationCard} from "../LoginInformationCard";
import {OtherRetirementPlans} from "../OtherRetirementPlans";
import {
    getPersonalInformationData,
    getPhoneNumber,
    getEmailAddress,
    getClientProfile,
    getPlanProfileOlaMessageData,
    getPlansInfoData,
    getPlansRulesData,
    getParticipantBeneficiaryData,
    getBeneMcCAmishSwitchData,
    getProfileMfaData,
    setSelectedPlanNumber,
    getParticipantConsents,
    getTaxRateBrackets,
    getCompensations,
    getRixScenario,
    getReferenceTypeValues,
    getParticipantTerminateOlaMessageData,
    getOtherRetirementPlansData,
    getServiceStatus,
    getDefinedBenefitParticipantBeneficiariesData,
    getPlanProducts,
    getServiceProducts,
    setIsPlansInfoDataLoaded,
    getSempraActivePlanNameOlaMsg, getSempraTerminatedPlanNameOlaMsg, setIsSempraPlan
} from "../../redux/profile/slice";
import {UseAppDispatch, UseAppSelector} from "../../redux/configure-store";
import {
    getCenturyPlan,
    getIsClientProfileLoaded,
    getIsGetEmailAddressLoaded,
    getIsGetPhoneNumberLoaded,
    getIsParticipantBeneficiaryDataLoaded,
    getIsPersonalInformationDataLoaded,
    getIsPlanProfileOlaMessageDataLoaded,
    getIsPlansInfoDataLoaded,
    getIsPlansRulesDataLoaded,
    getOnlineBeneficiary,
    getSelectedPlan,
    getReceivedPlansData,
    getTracPlan,
    getParticipantStatus,
    getIsBeneMcCAmishSwitchDataLoaded,
    getIsProfileMfaDataLoaded,
    getIsParticipantConsentDataLoaded,
    getIsRixScenarioLoaded,
    getIsClientProfileRejectedDataLoaded,
    getIsRixScenarioRejectedDataLoaded,
    getIsParticipantTerminateOlaMessageDataLoaded,
    getParticipantTerminateOlaMessageValue,
    getOtherRetirementPlans,
    getOtherRetirementPlanDataLoaded,
    getShowOldRetirementplans,
    getIsServiceStatusDataLoaded,
    getDefinedParticipantBenesArray,
    getIsDefinedBenefitParticipantBeneficiariesDataLoaded,
    getIsPlanProductsDataLoaded,
    getIsServiceProductsDataLoaded,
    getIsGetReferenceTypeValuesLoaded,
    getIsCompensationsDataLoaded,
    getIsTaxRateBracketsDataLoaded,
    getIsGetPhoneNumberLoadedRejected,
    getIsPersonalInformationDataLoadedRejected,
    getIsGetEmailAddressLoadedRejected,
    getIsPlanProfileOlaMessageDataLoadedRejected,
    getIsParticipantTerminateOlaMessageDataLoadedRejected,
    getIsBeneMcCAmishSwitchDataLoadedRejected,
    getIsDefinedBenefitParticipantBeneficiariesDataLoadedRejected,
    getIsPlansInfoDataLoadedRejected,
    getIsPlansRulesDataLoadedRejected,
    getIsGetReferenceTypeValuesLoadedRejected,
    getIsCompensationsDataRejected,
    getIsParticipantConsentDataRejected,
    getIsTaxRateBracketsDataRejected,
    getOtherRetirementPlanDataRejected,
    getIsServiceStatusDataRejected,
    getIsParticipantBeneficiaryDataRejected,
    getIsProfileMfaDataRejected,
    getIsServiceProductsDataRejected,
    getIsPlanProductsDataRejected,
    getIsUpdatePhoneNumberRejected,
    getIsSavePhoneNumberRejected,
    getIsUpdateEmailAddressRejected,
    getIsSaveOrUpdateClientProfileRejected,
    getIsUpdateCompensationsRejected,
    getIsSaveRixSalaryPayFrequencyRejected,
    getIsSaveOrUpdateRiSimulationRejected,
    getIsShowOrHideOtherRetirementPlansRejected
} from "../../redux/profile/selectors";
import Loading from "../Shared/Loading";
import {useSelector} from "react-redux";
import {selectedModalName} from "../../redux/modal/selectors";
import {isInternal} from "../../utils/api";


const StyledOuterContainer = styled.div`
  width: 100%;
`;

const StyledHeaderContainer = styled.div`
  background-image: linear-gradient(to bottom, #054c70 0%, #002f48 83%, #002f48 100%)
`;

const StyledInnerHeaderContainer = styled.div`
  max-width: 1264px;
  margin: 0 auto;
  padding: 0 88px 95px;
  box-sizing: content-box;
  @media (max-width: 768px) {
    padding: 0  32px 95px;
  }
  @media (min-width: 768px) and (max-width: 1024px){
    padding: 0 48px 95px;
  }
`;

const StyledInnerContainer = styled.div`
  max-width: 1264px;
  margin: 0 auto;
  padding: 0  88px 48px;
  display: flex;
  flex-direction: row;
  box-sizing: content-box;
  @media (min-width: 768px) and (max-width: 1024px){
    padding: 0 48px 48px;
  }
  @media (max-width: 768px) {
    padding: 0  32px 50px;
  }
  @media (max-width: 640px) {
    flex-direction: column;
    padding: 0 24px 68px;
  }
`;
const StyledContainer = styled.div`
  background-color: #f4f5f6;
`;

const StyledNotice = styled.div`
  background-color: #f4f5f6;
  padding: ${({hasError}) => hasError ? "32px 88px 600px !important" : "32px 88px 0" };
  @media (min-width: 768px) and (max-width: 1024px){
    padding: 32px 48px 0;
  }
  @media (max-width: 768px) {
    padding: ${({hasError}) => hasError ? "24px 32px 500px !important" : "24px 32px 32px" };
  }
  @media (max-width: 640px) {
    padding: ${({hasError}) => hasError ? "24px 24px 300px !important" : "24px" };
  }
`;
const StyledDisclaimerContainer = styled.div`
  max-width: 1180px;
  margin: 0 auto;
  padding: ${({hasError}) => hasError ? "32px 40px" : "24px 40px" };
  border-radius: 4px;
  border: ${({hasError}) => hasError ? "solid 1px #dd3636" : "solid 1px #ffad00" };
  background-color: ${({hasError}) => hasError ? "rgba(221, 54, 54, 0.08)" : "rgba(255, 173, 0, 0.16)" } ;
  font-family: var(--beacon-font-families-nimbus-sans-novus);
  font-size: 18px;
  line-height: 1.2;
  letter-spacing: 0.02px;
  color: #3b4b59;
  box-sizing: content-box;
  @media (max-width: 768px) {
    padding: 32px 24px;
  }
  @media (max-width: 640px) {
    font-size: 16px;
    padding: 24px 16px;
  }
`;
const StyledErrorMobileLink = styled.a`
  color: #086ea1;
  text-decoration: underline;
`;
const StyledLeftContainer = styled.div`
  width: 50%;
  padding-right:12px;
  box-sizing: border-box;
  margin-top: ${({showBanner}) => showBanner ? "32px": "-45px" };
  @media (max-width: 768px) {
    padding-right: 8px;
    margin-top: ${({showBanner}) => showBanner ? "0": "-45px" };
  }
  @media only screen and (max-width: 640px) {
    width: auto;
    padding-right: 0;
  }
`;

const StyledRightContainer = styled.div`
  width: 50%;
  padding-left: 12px;
  box-sizing: border-box;
  margin-top: ${({showBanner}) => showBanner ? "32px": "-45px" };
  @media (max-width: 768px) {
    padding-left: 8px;
    margin-top: ${({showBanner}) => showBanner ? "0": "-45px" };
  }
  @media only screen and (max-width: 640px) {
    width: auto;
    padding-left: 0;
    margin-top: 16px;
  }
`;

const HeaderText = styled.div`
  opacity: 0.9;
  font-family: var(--beacon-font-families-nimbus-sans-novus);
  font-weight: normal;
  color: #FFFFFF;
  padding: 56px 0 8px 0;
  font-size: 56px;
  line-height: 1.15;
  letter-spacing: normal;
  div {
    display: inline;
  }
  @media (max-width: 768px) {
    font-size: 36px;
  }
`;
const CaptionText = styled.div`
  height: 28px;
  align-self: stretch;
  font-weight: normal;
  color: #fff;
  font-family: var(--beacon-font-families-nimbus-sans-novus);
  font-size: 20px;
  line-height: 1.4;
  letter-spacing: 0.02px;
  div {
    display: inline;
  }
`;


const StyledMultiPlan = styled.div`
`;


const DisplayDesktop = styled.div`
  display: inline;
  &:hover,
  &:focus {
    text-decoration: none;
  }
`;

const StyledIcon = styled.img`
  width: 16px;
  height: 16px;
  cursor: pointer;
  pointer-events: none;
  @media all and (-ms-high-contrast: none) {
    margin: 0 0 0 -24px;
  }
  @media only screen and (max-width: 767px) {
    width: 32px;
    height: 32px;
  }
`;

const InvertedStyledIcon = styled.img`
  width: 16px;
  height: 16px;
  cursor: pointer;
  transform: rotate(180deg);
  @media all and (-ms-high-contrast: none) {
    margin: 0 0 0 -24px;
  }
`;
const StyledOnePlan = styled.div`
  color: #FFFFFF;
  font-size: 20px;
  @media only screen and (max-width: 640px) {
    font-size: 18px;
  }
`;

const DropdownDisplay = styled.div`
  width: 540px;
  height: 40px;
  margin-top: 4px;
  @media only screen and (max-width: 605px) {
    width: auto;
  }
  .Dropdown-control{
    justify-content: space-between;
    cursor: pointer;
    width: 540px;
    height: 40px;
    padding: 12px;
    display: flex;
    align-items: center;
    font-size: 18px;
    border-radius: 4px;
    border: solid 1px #bec3c8;
    background-color: #002f48;
    font-family: var(--beacon-font-families-nimbus-sans-novus);
    @media (max-width: 768px) {
      font-size: 16px;
    }
    @media only screen and (max-width: 605px) {
      width: auto;
    }
  }
  .Dropdown-arrow{
    background: url(${ArrowIcon}) no-repeat right;
  }
  .Dropdown-placeholder  {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  div{
    background-color: #002f48;
    color: #fff;
  }
    a {
        all: unset;
        &:hover {
            all: unset;
        }
    }
`;

export default  () => {
    const dispatch = UseAppDispatch();
    const modalName = useSelector(selectedModalName);
    useEffect(() => {
        // Gets the beacon-modal instance
        const modalInstance = document.getElementById(modalName);
        if(modalInstance){
            modalInstance.close();
        }

    },[])
    const plansData = UseAppSelector(getReceivedPlansData);
    const selectedPlan = UseAppSelector(getSelectedPlan);
    const defaultSelectedPlan = selectedPlan.label.type === 'a' ? selectedPlan : {
        label: <a>{selectedPlan.label}</a>,
        value: selectedPlan.value
    };
    const getPersonalInfoDataLoaded = UseAppSelector(getIsPersonalInformationDataLoaded);
    const IsGetPhoneNumberLoaded = UseAppSelector(getIsGetPhoneNumberLoaded);
    const isGetEmailAddressLoaded = UseAppSelector(getIsGetEmailAddressLoaded);
    const isPlanProfileOlaMessageDataLoaded = UseAppSelector(getIsPlanProfileOlaMessageDataLoaded);
    const isBeneMcCAmishSwitchDataLoaded = UseAppSelector(getIsBeneMcCAmishSwitchDataLoaded);
    const isClientProfileLoaded = UseAppSelector(getIsClientProfileLoaded);
    const isClientProfileRejectedDataLoaded = UseAppSelector(getIsClientProfileRejectedDataLoaded);
    const isPlansInfoDataLoaded = UseAppSelector(getIsPlansInfoDataLoaded);
    const isPlansRulesDataLoaded = UseAppSelector(getIsPlansRulesDataLoaded);
    const isProfileMfaDataLoaded = UseAppSelector(getIsProfileMfaDataLoaded);
    const isParticipantConsentDataLoaded = UseAppSelector(getIsParticipantConsentDataLoaded);
    const isRixScenarioLoaded = UseAppSelector(getIsRixScenarioLoaded);
    const isRixScenarioRejectedDataLoaded = UseAppSelector(getIsRixScenarioRejectedDataLoaded);
    const isParticipantBeneficiaryDataLoaded = UseAppSelector(getIsParticipantBeneficiaryDataLoaded);
    const isDefinedBenefitParticipantBeneficiariesDataLoaded = UseAppSelector(getIsDefinedBenefitParticipantBeneficiariesDataLoaded);
    const isParticipantTerminateOlaMessageDataLoaded = UseAppSelector(getIsParticipantTerminateOlaMessageDataLoaded);
    const participantTerminateOlaMessageData = UseAppSelector(getParticipantTerminateOlaMessageValue);
    const isOtherRetirementPlanDataLoaded = UseAppSelector(getOtherRetirementPlanDataLoaded);
    const isServiceStatusDataLoaded = UseAppSelector(getIsServiceStatusDataLoaded);
    const isPlanProductsDataLoaded = UseAppSelector(getIsPlanProductsDataLoaded);
    const isServiceProductsDataLoaded = UseAppSelector(getIsServiceProductsDataLoaded);
    const isGetReferenceTypeValuesLoaded = UseAppSelector(getIsGetReferenceTypeValuesLoaded);
    const isCompensationsDataLoaded = UseAppSelector(getIsCompensationsDataLoaded);
    const isTaxRateBracketsDataLoaded = UseAppSelector(getIsTaxRateBracketsDataLoaded);

    const isGetPhoneNumberLoadedRejected = UseAppSelector(getIsGetPhoneNumberLoadedRejected);
    const isPersonalInformationDataLoadedRejected = UseAppSelector(getIsPersonalInformationDataLoadedRejected);
    const isGetEmailAddressLoadedRejected = UseAppSelector(getIsGetEmailAddressLoadedRejected);
    const isPlanProfileOlaMessageDataLoadedRejected = UseAppSelector(getIsPlanProfileOlaMessageDataLoadedRejected);
    const isParticipantTerminateOlaMessageDataLoadedRejected = UseAppSelector(getIsParticipantTerminateOlaMessageDataLoadedRejected);
    const isBeneMcCAmishSwitchDataLoadedRejected = UseAppSelector(getIsBeneMcCAmishSwitchDataLoadedRejected);
    const isDefinedBenefitParticipantBeneficiariesDataLoadedRejected = UseAppSelector(getIsDefinedBenefitParticipantBeneficiariesDataLoadedRejected);
    const isPlansInfoDataLoadedRejected = UseAppSelector(getIsPlansInfoDataLoadedRejected);
    const isPlansRulesDataLoadedRejected = UseAppSelector(getIsPlansRulesDataLoadedRejected);
    const isGetReferenceTypeValuesLoadedRejected = UseAppSelector(getIsGetReferenceTypeValuesLoadedRejected);
    const isCompensationsDataRejected = UseAppSelector(getIsCompensationsDataRejected);
    const isParticipantConsentDataRejected = UseAppSelector(getIsParticipantConsentDataRejected);
    const isTaxRateBracketsDataRejected = UseAppSelector(getIsTaxRateBracketsDataRejected);
    const isOtherRetirementPlanDataRejected = UseAppSelector(getOtherRetirementPlanDataRejected);
    const isServiceStatusDataRejected = UseAppSelector(getIsServiceStatusDataRejected);
    const isPlanProductsDataRejected = UseAppSelector(getIsPlanProductsDataRejected);
    const isServiceProductsDataRejected = UseAppSelector(getIsServiceProductsDataRejected);
    const isProfileMfaDataRejected = UseAppSelector(getIsProfileMfaDataRejected);
    const isParticipantBeneficiaryDataRejected = UseAppSelector(getIsParticipantBeneficiaryDataRejected);
    //update and save calls rejected
    const isUpdatePhoneNumberRejected = UseAppSelector(getIsUpdatePhoneNumberRejected);
    const isSavePhoneNumberRejected = UseAppSelector(getIsSavePhoneNumberRejected);
    const isUpdateEmailAddressRejected = UseAppSelector(getIsUpdateEmailAddressRejected);
    const isSaveOrUpdateClientProfileRejected = UseAppSelector(getIsSaveOrUpdateClientProfileRejected);
    const isUpdateCompensationsRejected = UseAppSelector(getIsUpdateCompensationsRejected);
    const isSaveRixSalaryPayFrequencyRejected = UseAppSelector(getIsSaveRixSalaryPayFrequencyRejected);
    const isSaveOrUpdateRiSimulationRejected = UseAppSelector(getIsSaveOrUpdateRiSimulationRejected);
    const isShowOrHideOtherRetirementPlansRejected = UseAppSelector(getIsShowOrHideOtherRetirementPlansRejected);
    const sempraPlans = ["104815","105093","105002","999001","999051", "999052", "999003"];
    const isApiLoaded = getPersonalInfoDataLoaded && isPlanProductsDataLoaded && isServiceProductsDataLoaded && isDefinedBenefitParticipantBeneficiariesDataLoaded && IsGetPhoneNumberLoaded && isGetEmailAddressLoaded &&
        isPlanProfileOlaMessageDataLoaded && isPlansInfoDataLoaded && isPlansRulesDataLoaded &&
        (isClientProfileLoaded || isClientProfileRejectedDataLoaded) && isBeneMcCAmishSwitchDataLoaded  && isParticipantConsentDataLoaded && (isRixScenarioLoaded || isRixScenarioRejectedDataLoaded) && isParticipantTerminateOlaMessageDataLoaded && isOtherRetirementPlanDataLoaded &&
        isServiceStatusDataLoaded && isGetReferenceTypeValuesLoaded && isCompensationsDataLoaded && isTaxRateBracketsDataLoaded;

    const isApiRejected = isGetPhoneNumberLoadedRejected || isPersonalInformationDataLoadedRejected || isGetEmailAddressLoadedRejected || isPlanProfileOlaMessageDataLoadedRejected ||
        isParticipantTerminateOlaMessageDataLoadedRejected || isBeneMcCAmishSwitchDataLoadedRejected || isDefinedBenefitParticipantBeneficiariesDataLoadedRejected || isPlansInfoDataLoadedRejected ||
        isPlansRulesDataLoadedRejected || isGetReferenceTypeValuesLoadedRejected || isCompensationsDataRejected || isParticipantConsentDataRejected ||
        isParticipantConsentDataRejected || isTaxRateBracketsDataRejected || isOtherRetirementPlanDataRejected || isServiceStatusDataRejected || isPlanProductsDataRejected ||
        isServiceProductsDataRejected || isProfileMfaDataRejected || isParticipantBeneficiaryDataRejected || isUpdatePhoneNumberRejected || isSavePhoneNumberRejected ||
        isUpdateEmailAddressRejected || isSaveOrUpdateClientProfileRejected || isUpdateCompensationsRejected ||
        isSaveRixSalaryPayFrequencyRejected || isSaveOrUpdateRiSimulationRejected || isShowOrHideOtherRetirementPlansRejected;

    const planNumber = selectedPlan.value;
    const [isPlanChanged, setIsPlanChanged] = useState(false);
    const [isPlanBoolean, setIsPlanBoolean] = useState(false);
    useEffect(() => {
        if(!isApiLoaded || isPlanChanged) {
            dispatch(getPersonalInformationData(planNumber));
            dispatch(getPhoneNumber(planNumber));
            dispatch(getEmailAddress(planNumber));
            dispatch(getPlanProfileOlaMessageData(planNumber));
            dispatch(getParticipantTerminateOlaMessageData(planNumber));
            dispatch(getBeneMcCAmishSwitchData(planNumber));
            dispatch(getDefinedBenefitParticipantBeneficiariesData(planNumber));
            dispatch(getPlansInfoData(planNumber));
            dispatch(getPlansRulesData(planNumber));
            dispatch(getClientProfile());
            dispatch(getReferenceTypeValues(52));
            dispatch(getReferenceTypeValues(53));
            dispatch(getReferenceTypeValues(64));
            dispatch(getRixScenario())
            dispatch(getCompensations())
            dispatch(getParticipantConsents(planNumber));
            dispatch(getTaxRateBrackets());
            dispatch(getOtherRetirementPlansData(planNumber));
            dispatch(getServiceStatus(planNumber));
            dispatch(getPlanProducts(planNumber));
            dispatch(getServiceProducts(planNumber));
            if (!isInternal()) {
                dispatch(getProfileMfaData());
            }
            if(sempraPlans.includes(planNumber)){
                dispatch(getSempraActivePlanNameOlaMsg(planNumber));
                dispatch(getSempraTerminatedPlanNameOlaMsg(planNumber));
                dispatch(setIsSempraPlan(true));
            }else{
                dispatch(setIsSempraPlan(false));
            }
        }
    }, [isPlanBoolean]);

    useEffect(() => {
        if(!isApiLoaded || isPlanChanged) {
            if (isPlansInfoDataLoaded && !isTracPlan) {
                dispatch(getParticipantBeneficiaryData(planNumber));
            }
        }
    }, [isPlansInfoDataLoaded, isPlanBoolean]);
    const participantStatus = UseAppSelector(getParticipantStatus);
    const isTracPlan = UseAppSelector(getTracPlan);
    const isCenturyPlan = UseAppSelector(getCenturyPlan);
    const isRetailTracPlan = !isCenturyPlan && isTracPlan;
    const isOnlineBeneficiary = UseAppSelector(getOnlineBeneficiary);
    const trpPlan = '999995';
    const isTrpPlanIndicator = planNumber === trpPlan;
    const showBeneCard = ((isOnlineBeneficiary && !(isTrpPlanIndicator && participantStatus === '03' )) || isTracPlan ) && !(!isCenturyPlan && isTracPlan);
    let hasOnlyOnePlan = plansData.length === 1? plansData[0].planName : null;
    const otherRetirementPlans = UseAppSelector(getOtherRetirementPlans);
    const showOtherRetirementsPlanCard = otherRetirementPlans===null? false:otherRetirementPlans.length>0?true:false;
    const showOldRetirementplansInDropDown = UseAppSelector(getShowOldRetirementplans);
    const definedParticipantBenesArray = UseAppSelector(getDefinedParticipantBenesArray);
    const showPensionBeneCard = definedParticipantBenesArray && definedParticipantBenesArray.length > 0;

    let optionsData = plansData.map((plan:any) => {
        return {
            label: <a>{plan.planName}</a>,
            value: plan.planNumber
        }
    });

    if(showOtherRetirementsPlanCard && !showOldRetirementplansInDropDown){
        //remove Other Retirement Plans from OptionsData(Dropdown)
        let tempOptions = [];
        optionsData.map((ele)=>{
            let containsElement = false;
            otherRetirementPlans.map((element)=>{
                if(Object.values(element).includes(ele.label))
                    containsElement = true;
            })
            if(!containsElement)
                tempOptions.push(ele)
        })
        optionsData = tempOptions;
        if(tempOptions.length === 1)
            hasOnlyOnePlan = tempOptions[0].label;
    }
    else if(showOtherRetirementsPlanCard && showOldRetirementplansInDropDown){
        //add Other Retirement Plans to OptionsData(Dropdown) without duplicating
        otherRetirementPlans.map((ele)=>{
            let containsElement = false;
            optionsData.map((element)=>{
                if(Object.values(element).includes(ele.planName))
                    containsElement = true;
            })
            if(!containsElement)
                optionsData.push({label:<a>{ele.planName}</a>, value:ele.planNumber})
        })
    }
    const handlePlanChange = (planOption:any) => {
        dispatch(setSelectedPlanNumber(planOption));
        setIsPlanChanged(true);
        setIsPlanBoolean(!isPlanBoolean);
        dispatch(setIsPlansInfoDataLoaded(false));
    }

    if(!isApiLoaded && !isApiRejected){
        return <Loading topMargin="20% auto 20%" />
    }

    return (
        <>
                <StyledOuterContainer id={`profile-container`}>
                    <StyledHeaderContainer>
                        <StyledInnerHeaderContainer>
                            <HeaderText >
                                Profile
                            </HeaderText>
                            {hasOnlyOnePlan ?
                                <StyledOnePlan>
                                    {hasOnlyOnePlan}
                                </StyledOnePlan>
                                :
                                <StyledMultiPlan>
                                    <CaptionText>
                                        Select your plan
                                    </CaptionText>
                                    <DisplayDesktop>
                                        <DropdownDisplay>
                                            <Dropdown
                                                options = {optionsData}
                                                value = {defaultSelectedPlan}
                                                onChange={handlePlanChange}
                                                arrowClosed =
                                                    {<span>
                                <StyledIcon
                                    id={'arrow-icon-closed'}
                                    src={ArrowIcon}
                                    alt="arrow icon closed"/>
                                </span>
                                                    }
                                                arrowOpen={
                                                    <span>
                                <InvertedStyledIcon
                                    id={'arrow-icon-open'}
                                    src={ArrowIcon}
                                    alt="arrow icon open"/>
                                </span>
                                                }
                                            />
                                        </DropdownDisplay>
                                    </DisplayDesktop>
                                </StyledMultiPlan>
                            }
                        </StyledInnerHeaderContainer>

                    </StyledHeaderContainer>

                    <StyledContainer>
                        {(isApiRejected && !isApiLoaded)?
                            (<StyledNotice hasError={true}>
                                <StyledDisclaimerContainer hasError={true}>
                                    {` We are sorry, but your request cannot be completed at this time. Please try again later. If you continue to receive this message, please call us at`} <StyledErrorMobileLink href="tel:+1800-922-9945">800-922-9945</StyledErrorMobileLink>{`.`}
                                </StyledDisclaimerContainer>
                            </StyledNotice>)

                            :
                            <>

                                {participantTerminateOlaMessageData && !isRetailTracPlan &&
                                    <StyledNotice>
                                        <StyledDisclaimerContainer dangerouslySetInnerHTML={{__html: `${participantTerminateOlaMessageData}`}}/>
                                    </StyledNotice>

                                }

                                {isRetailTracPlan &&
                                    <StyledNotice hasError={true}>
                                        <StyledDisclaimerContainer hasError={true}>
                                            {`Your Profile information for this plan is not available online. For assistance, please call us at `} 
                                            <StyledErrorMobileLink href="tel:+1800-492-7670">800-492-7670</StyledErrorMobileLink>{`.`}
                                        </StyledDisclaimerContainer>
                                    </StyledNotice>
                                }

                                {!isRetailTracPlan &&
                                    <StyledInnerContainer>
                                        <StyledLeftContainer showBanner={!!participantTerminateOlaMessageData}>
                                            <PersonalInformationCard/>
                                            <PreferencesCard/>
                                            {showBeneCard && <BeneficiaryCard/>}
                                            {showPensionBeneCard && <PensionBeneficiariesCard/>}
                                        </StyledLeftContainer>

                                        <StyledRightContainer showBanner={!!participantTerminateOlaMessageData}>
                                            <PlanningInformationCard/>
                                            <AboutYourselfCard/>
                                            <LoginInformationCard/>
                                            {showOtherRetirementsPlanCard && <OtherRetirementPlans/>}
                                        </StyledRightContainer>
                                    </StyledInnerContainer>
                                }
                            </>
                        }
                    </StyledContainer>
                </StyledOuterContainer>
        </>
    );
};

